module.exports = __webpack_public_path__ + "img/wx.794e7678.png";